import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "content-card-list" }
const _hoisted_2 = { class: "content-card-list__image-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "timer content-card-list__timer"
}
const _hoisted_4 = { class: "timer__text" }
const _hoisted_5 = {
  key: 1,
  class: "news-card__gallery-badge"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Galéria ")
const _hoisted_7 = { class: "content-card-list__right" }
const _hoisted_8 = { class: "content-card-list__date" }
const _hoisted_9 = {
  key: 0,
  class: "content-card-list__title"
}
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Play = _resolveComponent("Play")!
  const _component_GalleryFull = _resolveComponent("GalleryFull")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Image = _resolveComponent("Image")!
  const _component_nav_link = _resolveComponent("nav-link")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(_component_nav_link, { to: _ctx.url }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.showDuration && _ctx.isVideo && _ctx.videoDuration)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_Play),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.videoDuration), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showGalleryBadge && _ctx.isGallery)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_GalleryFull),
                _hoisted_6
              ]))
            : _createCommentVNode("", true),
          (_ctx.showTag && _ctx.tag)
            ? (_openBlock(), _createBlock(_component_Tag, {
                key: 2,
                class: "content-card-list__tag",
                tag: _ctx.tag,
                "is-live": _ctx.isLive
              }, null, 8, ["tag", "is-live"]))
            : _createCommentVNode("", true),
          _createVNode(_component_Image, {
            "image-url": _ctx.imageUrl,
            alt: _ctx.title,
            class: "content-card-list__image"
          }, null, 8, ["image-url", "alt"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$d(_ctx.releaseDate, 'long')), 1),
          (_ctx.showTitle && _ctx.title)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_9, _toDisplayString(_ctx.title), 1))
            : _createCommentVNode("", true),
          ((_ctx.showLead && _ctx.lead))
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["content-card-list__excerpt", {
            'content-card-list__excerpt--large': !_ctx.showTitle
          }]),
                innerHTML: _ctx.lead
              }, null, 10, _hoisted_10))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}